export default __webpack_public_path__ + "static/media/building-type.5010cd97.svg";